import { UseEventAccommodationsCheckReturn } from '@shared/hooks/useEventAccommodationsCheck';
import { useMemo } from 'react';
import { useGetAccommodationsBaseUrl } from './useGetAccommodationsBaseUrl';
import { getProposedBookingDates } from './AccommodationsPushStep.utils';
import { useClientReference } from '@shared/hooks/useClientReference';

const JOY_ACCOMMODATIONS_BASE_URL = 'https://stays.withjoy.com/hotels';

type UseAccommodationsRedirectUrlArgs = {
  eventId: string;
} & Pick<UseEventAccommodationsCheckReturn, 'eventFinalizedDate' | 'eventLocationPlaceId' | 'eventLocationCityName'>;

const urlParamsToRecord = (params: URLSearchParams): Record<string, string> => {
  const output: Record<string, string> = Object.fromEntries(params.entries());

  return output;
};

export const useAccommodationSearchPageRedirectUrl = (args: UseAccommodationsRedirectUrlArgs) => {
  const { eventFinalizedDate, eventLocationPlaceId, eventLocationCityName } = args;
  const accommodationsUrl = useGetAccommodationsBaseUrl(JOY_ACCOMMODATIONS_BASE_URL);

  const { clientReference } = useClientReference();

  return useMemo(() => {
    const redirectUrl = new URL(accommodationsUrl);
    const searchParams = redirectUrl.searchParams;

    searchParams.append('clientReference', clientReference);

    if (eventLocationPlaceId) {
      searchParams.append('placeId', eventLocationPlaceId);
    }

    if (eventLocationCityName) {
      searchParams.append('name', eventLocationCityName);
    }

    if (eventFinalizedDate) {
      const { checkin, checkout } = getProposedBookingDates(eventFinalizedDate);
      searchParams.append('checkin', checkin);
      searchParams.append('checkout', checkout);
    }

    return { url: redirectUrl.href, params: urlParamsToRecord(searchParams) };
  }, [accommodationsUrl, clientReference, eventLocationPlaceId, eventLocationCityName, eventFinalizedDate]);
};
